import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  REQUEST_CAREER,
  REQUEST_CAREER_FAILURE,
  REQUEST_CAREER_SUCCESS,
} from '../constants/ActionTypes';

import { STRING, DATE } from '../constants/DataTypes';
import { fields, detailFields, entityMap } from '../constants/fields/EmployeeMasterCareer';
import convert from '../utils/dateTools';

export function mapCareer(c) {
  return {
    fields,
    detailFields,
    entityMap,
    Entity: c.Entity,
    CareerEmployer: {
      label: <div><FormattedMessage id="career.employer" /></div>,
      value: c.CareerEmployer,
      type: STRING,
      entity: 'CareerEmployer',
    },
    CareerJob: {
      label: <div><FormattedMessage id="career.job" /></div>,
      value: c.CareerJob,
      type: STRING,
      entity: 'CareerJob',
    },
    CareerCity: {
      label: <div><FormattedMessage id="career.city" /></div>,
      value: c.CareerCity,
      type: STRING,
      entity: 'CareerCity',
    },
    CareerCountryName: {
      label: <div><FormattedMessage id="career.country" /></div>,
      value: c.CareerCountryName,
      type: STRING,
      entity: 'CareerCountryID',
    },
    CareerPeriodBegda: {
      label: <div><FormattedMessage id="career.from" /></div>,
      value: convert(c.CareerPeriodBegda),
      type: DATE,
      entity: 'CareerPeriodBegda',
    },
    CareerPeriodEnda: {
      label: <div><FormattedMessage id="career.to" /></div>,
      value: convert(c.CareerPeriodEnda),
      type: DATE,
      entity: 'CareerPeriodEnda',
    },
  };
}

export default function careerReducer(state = {}, action) {
  switch (action.type) {
    case REQUEST_CAREER:
      return {
        ...state,
        isFetching: true,
        careerData: [],
        loaded: false,
      };

    case REQUEST_CAREER_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        loaded: true,
      };

    case REQUEST_CAREER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        careerData: action.careerData.map(mapCareer),
        lastUpdated: action.receivedAt,
        loaded: true,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/careerReducer.js